import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LPAlt from "../pages/lp-alt/page";
import Blog from "../pages/blog/page";
import BlogArticle from "../pages/blog/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/lp-alt",
    element: <LPAlt />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
